import styled from '@emotion/styled';
import { Chip as _Chip, Typography } from '@material-ui/core';
import { Today } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';
import { FormattedDate } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Props = ClassAttributes<HTMLElement> & {
  offer: {
    expectedDue: Date;
    expressDelivery: boolean;
  };
  className?: string;
};

const OfferDeadlineDisplay = ({ offer, className }: Props) => (
  <Root className={className}>
    <Icon />
    <div>
      <Label>
        <FormattedMessage id="offer_deadline_display.label" />:
      </Label>
      <DeadlineDate noWrap>
        <FormattedDate
          value={offer.expectedDue}
          year="numeric"
          month="short"
          day="numeric"
          hour="numeric"
          minute="numeric"
        />
      </DeadlineDate>
    </div>
    {offer.expressDelivery ? <Chip label={<FormattedMessage id="offer_deadline_display.express" />} /> : null}
  </Root>
);

const Root = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
    wrap: 'wrap',
  }),
  maxWidth: 280,
});

const Icon = styled(Today)({
  marginRight: 6,
});

const Label = styled(Typography)({
  marginRight: '0.5em',
  fontSize: 12,
  fontWeight: 500,
  whiteSpace: 'nowrap',
});

const DeadlineDate = styled(Typography)({
  fontWeight: 500,
});

const Chip = styled(_Chip)({
  marginLeft: SPACING_UNIT,
});

export default OfferDeadlineDisplay;
